import { query } from '@confluence/query-preloader-tools';
import { preloadWebItemLocation } from '@confluence/web-item-location/entry-points/preloadWebItemLocation';

import { AppNavigationUnifiedQuery } from './AppNavigationUnifiedQuery.graphql';

export function preloadAppNavigation() {
	const appNavigationPromises = [
		query({
			query: AppNavigationUnifiedQuery,
		}),
		preloadWebItemLocation({
			location: 'system.header/left',
		}),
	];

	return Promise.all(appNavigationPromises);
}
